import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import 'chart.js/auto';
import { Chart } from '@totalsoft/rocket-ui';
import { getChartColors } from 'features/dashboard/utils';
import { useTheme } from '@mui/material';

const DashboardDoughnutChart = ({ indicator }) => {
  const theme = useTheme();

  const labels = useMemo(() => indicator.pie.map(item => item.label), [indicator]);

  const datasets = useMemo(
    () => [
      {
        data: indicator.pie.map(item => item.value),
        backgroundColor: getChartColors(theme.palette.primary.main, indicator.pie.length),
        cutout: '65%',
        borderWidth: 0,
        borderRadius: 10,
        spacing: 4
      }
    ],
    [indicator, theme]
  );

  const data = useMemo(() => ({ labels, datasets }), [labels, datasets]);

  return (
    <Chart
      title={indicator.title}
      type='doughnut'
      data={data}
      cardProps={{ sx: { height: '100%' } }}
      height={300}
      options={{
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 15
            }
          }
        }
      }}
    />
  );
};

DashboardDoughnutChart.propTypes = {
  indicator: PropTypes.object.isRequired
};

export default DashboardDoughnutChart;
